var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "cb4x-content" } },
    [
      _c("h4", [_vm._v(_vm._s(_vm.headerBlock.title))]),
      _vm._v(" "),
      _c(
        "p",
        [
          _c("ob1-capsule", {
            attrs: { "is-information": true, label: _vm.headerBlock.feesLabel },
          }),
          _vm._v(" "),
          _c("strong", [_vm._v(_vm._s(_vm.headerBlock.subTitle))]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {
        style: _vm.widgetLoaded ? "" : "display: none;",
        attrs: { id: "widget-oney" },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "ob1-skeleton widget-skeleton",
          style: { display: _vm.widgetLoaded ? "none" : "" },
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("hr", { staticClass: "separator my-1 separator--gray4" }),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _vm._m(4),
        ]
      ),
      _vm._v(" "),
      _vm.illustration
        ? _c(
            "div",
            { staticClass: "row pt-2 pb-1" },
            [
              _c("ob1-picture", {
                staticClass: "illustration",
                attrs: {
                  visual: _vm.illustration,
                  "css-classes": "d-block mx-auto",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.howToBenefit
        ? [
            _c(
              "div",
              { staticClass: "bg-gray2 px-2 pb-1 mb-1 mb-md-2" },
              [
                _c("p", { staticClass: "mb-0" }, [
                  _c("span", { staticClass: "lead" }, [
                    _c("strong", [_vm._v(_vm._s(_vm.howToBenefit.title))]),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("strong", [_vm._v(_vm._s(_vm.howToBenefit.subTitle))]),
                ]),
                _vm._v(" "),
                _vm._l(
                  _vm.howToBenefit.texts,
                  function (howToBenefitText, index) {
                    return _c(
                      "p",
                      {
                        key: "how-to-" + index,
                        staticClass: "d-flex align-items-center mb-0",
                      },
                      [
                        _c("span", {
                          staticClass: "font-size-24",
                          class:
                            "icon-number-" + _vm.getIndex(index) + "-wired",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "ms-1",
                          domProps: { innerHTML: _vm._s(howToBenefitText) },
                        }),
                      ]
                    )
                  }
                ),
              ],
              2
            ),
            _vm._v(" "),
            _vm.howToBenefit.link
              ? _c(
                  "div",
                  { staticClass: "text-center mt-2 mb-4" },
                  [
                    _c("ob1-boutons", {
                      attrs: {
                        label: _vm.howToBenefit.link.label,
                        href: _vm.howToBenefit.link.url,
                        target: "_blank",
                        "is-button": false,
                        "is-secondary": "",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ob1-liens-haut-bas",
        {
          attrs: {
            "is-collapsed": false,
            "collapsed-block-id": "legal-mentions-4xcb-block",
            "button-label": _vm.cgu.title,
            "button-id": "legal-mentions-4xcb-link",
          },
        },
        [_c("p", { domProps: { innerHTML: _vm._s(_vm.cgu.text) } })]
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex" }, [
      _c("div", {
        staticClass: "me-auto justify-content-start ob1-skeleton-white",
        staticStyle: { width: "130px", height: "20px" },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "justify-content-end ob1-skeleton-white",
        staticStyle: { width: "70px", height: "20px" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex" }, [
      _c("div", {
        staticClass: "me-auto justify-content-start ob1-skeleton-white",
        staticStyle: { width: "80px", height: "20px" },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "justify-content-end ob1-skeleton-white mb-1",
        staticStyle: { width: "70px", height: "20px" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex" }, [
      _c("div", {
        staticClass: "me-auto justify-content-start ob1-skeleton-white",
        staticStyle: { width: "160px", height: "20px" },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "justify-content-end ob1-skeleton-white mb-1",
        staticStyle: { width: "70px", height: "20px" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex" }, [
      _c("div", {
        staticClass: "me-auto justify-content-start ob1-skeleton-white",
        staticStyle: { width: "150px", height: "20px" },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "justify-content-end ob1-skeleton-white mb-1",
        staticStyle: { width: "50px", height: "20px" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex" }, [
      _c("div", {
        staticClass: "me-auto justify-content-start ob1-skeleton-white",
        staticStyle: { width: "50px", height: "20px" },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "justify-content-end ob1-skeleton-white mb-1",
        staticStyle: { width: "50px", height: "20px" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }